export default {
  saledFeedback: 'アフターサービスフィードバック',
  orderNo: 'オーダー番号',
  unreply: '返信なし',
  replied: '返信済み',
  apply: '申請',
  badImg: '不良画像',
  applyDetail: '申請の詳細',
  replyDate: '返信日',
  replyContent: '返信内容',
  orderMsg: '注文メッセージ',
  otherMsg: 'その他のメッセージ',
  clickUpload: 'アップロード',
  uploadRefreshTip: 'すべての画像のアップロードが成功するか、ネットワーク上の問題が発生するのを待って、ページを更新して再アップロードしてください',
  uploadNumberTip: '最大4枚の画像をアップロードできます',
};